import React, { useState } from 'react';
import cx from 'classnames';
import { useDispatch } from 'react-redux';

import CheckBoxGroupForm from '../../../../../components/form/CheckBoxGroupForm';
import Button from '../../../../../components/Button';
import CheckBoxGroup from '../../../../../components/input/CheckBoxGroup';
import Anchor from '../../../../../components/link/Anchor';
import useConfirmPropertyMutate from '../../../../../hooks/queries/product/useConfirmPropertyMutate';
import { asyncSimpleModal } from '../../../../../lib/common';
import { productActions } from '../../../../../store/modules/product';
import { PRODUCT_PROPERTY_REJECT_TYPE_TEXT } from '../../../../../constants/service/app/productConstants';
import {
  CONFIRM_PROPERTY_LIST_TYPE,
  CONFIRM_PROPERTY_LIST_TYPE_TEXT,
} from '../../../../../constants/service/app/tagConstants';
import './PropertyItem.scss';

const PropertyItem = (props) => {
  const {
    className,
    isEditable,
    form,
    name,
    title,
    list,
    rules,
    productId,
    value,
    confirm,
    rejectInfo,
    subContent,
    onChangeCheckBox,
  } = props;
  const isRequired = rules?.find(({ required }) => !!required);
  const [type, setType] = useState(CONFIRM_PROPERTY_LIST_TYPE.ACTIVE);
  const { confirmProperty } = useConfirmPropertyMutate(setType);
  const dispatch = useDispatch();

  const onConfirmProperty = () => {
    confirmProperty.mutate({
      productId,
      productPropertyType: name,
    });
  };
  const onRejectProperty = () => {
    dispatch(
      productActions.toggleModal({
        name: 'rejectRegistrationProductPropertyModal',
        value: true,
        data: {
          productId,
          productPropertyType: name,
          setType,
        },
      }),
    );
  };

  return (
    <div className={cx(className, 'property-item')}>
      <div className={cx('property-item-title', 'label', { required: isRequired })}>{title}</div>
      <div className="property-item-content">
        {confirm[CONFIRM_PROPERTY_LIST_TYPE.CONFIRM_READY] !== null ||
        confirm[CONFIRM_PROPERTY_LIST_TYPE.REJECT] !== null ? (
          <div className="property-item-type-list">
            {/* 노출 중인 속성 */}
            <Button
              type="button"
              className="confirm-property-type-button"
              color={CONFIRM_PROPERTY_LIST_TYPE.ACTIVE === type ? 'primary' : 'light'}
              onClick={() => setType(CONFIRM_PROPERTY_LIST_TYPE.ACTIVE)}
              text={CONFIRM_PROPERTY_LIST_TYPE_TEXT[CONFIRM_PROPERTY_LIST_TYPE.ACTIVE]}
            />

            {/* 검수 요청 중인 태그 */}
            {confirm[CONFIRM_PROPERTY_LIST_TYPE.CONFIRM_READY] !== null ? (
              <Button
                type="button"
                className="confirm-property-type-button"
                color={CONFIRM_PROPERTY_LIST_TYPE.CONFIRM_READY === type ? 'primary' : 'light'}
                onClick={() => setType(CONFIRM_PROPERTY_LIST_TYPE.CONFIRM_READY)}
                text={CONFIRM_PROPERTY_LIST_TYPE_TEXT[CONFIRM_PROPERTY_LIST_TYPE.CONFIRM_READY]}
              />
            ) : null}

            {/* 승인 거절된 태그 */}
            {confirm[CONFIRM_PROPERTY_LIST_TYPE.REJECT] !== null ? (
              <Button
                type="button"
                className="confirm-property-type-button"
                color={CONFIRM_PROPERTY_LIST_TYPE.REJECT === type ? 'primary' : 'gray'}
                onClick={() => setType(CONFIRM_PROPERTY_LIST_TYPE.REJECT)}
                text={CONFIRM_PROPERTY_LIST_TYPE_TEXT[CONFIRM_PROPERTY_LIST_TYPE.REJECT]}
              />
            ) : null}
          </div>
        ) : null}

        <div className={cx('property-item-active-type-form', { active: CONFIRM_PROPERTY_LIST_TYPE.ACTIVE === type })}>
          <CheckBoxGroupForm
            disabled={!isEditable}
            form={form}
            name={`${name}Id`}
            list={list}
            rules={rules}
            initialValue={value.map((item) => item.id)}
            subContent={subContent}
            onChange={(values) => onChangeCheckBox({ values, key: name })}
          />
          {subContent}
        </div>
        {CONFIRM_PROPERTY_LIST_TYPE.ACTIVE !== type ? (
          <>
            <CheckBoxGroup
              className={cx(`property-item-${type}-type-form`)}
              list={list}
              value={confirm[type]?.map((item) => item.id)}
              size="large"
              disabled={true}
            />
          </>
        ) : null}

        {CONFIRM_PROPERTY_LIST_TYPE.CONFIRM_READY === type ? (
          <div className="property-item-submit-list">
            <Button
              type="button"
              className="confirm-property-button"
              color="primary"
              onClick={onConfirmProperty}
              text="승인하기"
            />

            <Button
              type="button"
              className="confirm-property-button"
              color="light"
              onClick={onRejectProperty}
              text="거절하기"
            />
          </div>
        ) : null}
        {CONFIRM_PROPERTY_LIST_TYPE.REJECT === type ? (
          <div className="rejected-property-info">
            <span className="rejected-property-type">거절 사유: </span>
            <Anchor
              color="primary"
              isUnderLine
              onClick={async () =>
                await asyncSimpleModal({
                  title: '거절 사유',
                  message: rejectInfo.reason,
                })
              }
              text={PRODUCT_PROPERTY_REJECT_TYPE_TEXT[rejectInfo.type]}
            />
          </div>
        ) : null}
      </div>
    </div>
  );
};

export default PropertyItem;
